import type React from 'react';
import { connect } from 'react-redux';

import displayValues from '../../resources/displayValues.json';
import { fetchResults } from '../../state/resultActions';
import { actions as filterActions } from '../../state/filterActions';

import type { ApiQueryParams, PaleState } from '../../interfaces';

interface Props {
    defaultValue: string;
    selectedValue?: string;
    sortOptions: string[];
    displayOptions: Record<string, string>;
    selectId?: string;
    filterChange: (newSortValue?: string) => void;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
}

export const SortDropdown: React.FC<Props> = ({
    defaultValue,
    selectedValue,
    sortOptions,
    displayOptions,
    filterChange,
    triggerFetch,
    selectId = 'sortDropdown',
}): React.ReactElement<Props> => {
    const onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        if (event.target.value === defaultValue) {
            filterChange(undefined);
        } else {
            filterChange(event.target.value);
        }
        triggerFetch();
    };

    const isDev = process.env.NODE_ENV === 'development';

    return (
        <div className="input u-mb0 input--select sort-dropdown">
            <label htmlFor={selectId}>Sorter på</label>
            <div className="input--select__wrap">
                <select
                    data-testid={selectId}
                    id={selectId}
                    size={1}
                    value={selectedValue || defaultValue}
                    onChange={onChange}
                    onBlur={(): undefined => undefined}>
                    {sortOptions.reduce((options: React.ReactElement[], value: string): React.ReactElement[] => {
                        if (displayOptions[value] || isDev) {
                            const option = (
                                <option key={value} value={value}>
                                    {displayOptions[value]}
                                </option>
                            );
                            return options.concat(option);
                        }
                        return options;
                    }, [])}
                </select>
            </div>
        </div>
    );
};

const mapStateToProps = (state: PaleState): Pick<Props, 'defaultValue' | 'selectedValue' | 'sortOptions' | 'displayOptions'> => ({
    defaultValue: state.results.defaultSort,
    selectedValue: state.filters.sort,
    sortOptions: state.results.sortOptions,
    displayOptions: displayValues.sorting,
});

const mapDispatchToProps = { triggerFetch: fetchResults, filterChange: filterActions.changeSort };

export default connect(mapStateToProps, mapDispatchToProps)(SortDropdown);
